import styled from 'styled-components';
import Page from 'components/Page';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const StyledPage = styled(Page)`
  padding-top: 94px;
  margin-top: 0;
  @media (min-width: ${DEVICE.laptop}) {
    padding: 0 64px 100px;
    margin: 24px auto 0;
  }
`;

export const Wrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 0 20px;
`;
